// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from "./axios";
// Simple notification functions
const showSuccess = (title, message) => {
  console.log(`Success: ${title} - ${message}`);
  // You can integrate with your preferred notification system here
};

const showError = (title, message) => {
  console.error(`Error: ${title} - ${message}`);
  // You can integrate with your preferred notification system here
};

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const useAuditLogStore = create(immer((set, get) => ({
  auditLogs: [],
  loading: false,
  pagination: {
    page: 1,
    limit: 50,
    total: 0,
    pages: 0
  },
  filters: {
    userId: '',
    method: '',
    url: '',
    status: '',
    leagueId: '',
    startDate: '',
    endDate: '',
    sortBy: 'createdAt',
    sortOrder: 'desc'
  },
  stats: {
    methodStats: [],
    topUsers: [],
    topEndpoints: [],
    dailyActivity: [],
    totalLogs: 0
  },

  // Set loading state
  setLoading: (loading) => {
    set((state) => {
      state.loading = loading;
    });
  },

  // Set filters
  setFilters: (filters) => {
    set((state) => {
      state.filters = { ...state.filters, ...filters };
      state.pagination.page = 1; // Reset to first page when filters change
    });
  },

  // Reset filters
  resetFilters: () => {
    set((state) => {
      state.filters = {
        userId: '',
        method: '',
        url: '',
        status: '',
        leagueId: '',
        startDate: '',
        endDate: '',
        sortBy: 'createdAt',
        sortOrder: 'desc'
      };
      state.pagination.page = 1;
    });
  },

  // Get audit logs with filtering and pagination
  getAuditLogs: (getToken) => {
    return async (filters = {}) => {
      try {
        const token = await getToken();
        set((state) => {
          state.loading = true;
        });

        // Merge with existing filters
        const currentFilters = get().filters;
        const queryParams = new URLSearchParams();
        
        // Add pagination
        queryParams.append('page', get().pagination.page || 1);
        queryParams.append('limit', get().pagination.limit || 50);
        
        // Add filters
        Object.entries({ ...currentFilters, ...filters }).forEach(([key, value]) => {
          if (value && key !== 'page' && key !== 'limit') {
            queryParams.append(key, value);
          }
        });

        const { data } = await axios.get(
          `${baseUrl}/auditLogs?${queryParams.toString()}`,
          createAuthHeader(token)
        );

        if (data.status === 1) {
          set((state) => {
            state.auditLogs = data.result.logs;
            state.pagination = data.result.pagination;
            state.loading = false;
          });
        } else {
          showError("Error", data.error || "Failed to fetch audit logs");
          set((state) => {
            state.loading = false;
          });
        }
      } catch (error) {
        console.error("Error in getAuditLogs:", error);
        showError("Error", "Failed to fetch audit logs");
        set((state) => {
          state.loading = false;
        });
      }
    };
  },

  // Get audit log statistics
  getAuditLogStats: (getToken) => {
    return async (filters = {}) => {
      try {
        const token = await getToken();
        const queryParams = new URLSearchParams();
        
        // Add filters for stats
        Object.entries(filters).forEach(([key, value]) => {
          if (value) {
            queryParams.append(key, value);
          }
        });

        const { data } = await axios.get(
          `${baseUrl}/auditLogs/stats?${queryParams.toString()}`,
          createAuthHeader(token)
        );

        if (data.status === 1) {
          set((state) => {
            state.stats = data.result;
          });
        } else {
          showError("Error", data.error || "Failed to fetch audit log statistics");
        }
      } catch (error) {
        console.error("Error in getAuditLogStats:", error);
        showError("Error", "Failed to fetch audit log statistics");
      }
    };
  },

  // Get specific audit log by ID
  getAuditLogById: (getToken) => {
    return async (id) => {
      try {
        const token = await getToken();
        const { data } = await axios.get(
          `${baseUrl}/auditLogs/${id}`,
          createAuthHeader(token)
        );

        if (data.status === 1) {
          return data.result;
        } else {
          showError("Error", data.error || "Failed to fetch audit log");
          return null;
        }
      } catch (error) {
        console.error("Error in getAuditLogById:", error);
        showError("Error", "Failed to fetch audit log");
        return null;
      }
    };
  },

  // Cleanup old audit logs
  cleanupOldLogs: (getToken) => {
    return async (days = 90) => {
      try {
        const token = await getToken();
        const { data } = await axios.delete(
          `${baseUrl}/auditLogs/cleanup?days=${days}`,
          createAuthHeader(token)
        );

        if (data.status === 1) {
          showSuccess("Success", `Cleaned up ${data.result.deletedCount} old audit logs`);
          return data.result.deletedCount;
        } else {
          showError("Error", data.error || "Failed to cleanup old audit logs");
          return 0;
        }
      } catch (error) {
        console.error("Error in cleanupOldLogs:", error);
        showError("Error", "Failed to cleanup old audit logs");
        return 0;
      }
    };
  },

  // Set pagination
  setPagination: (pagination) => {
    set((state) => {
      state.pagination = { ...state.pagination, ...pagination };
    });
  },

  // Clear audit logs
  clearAuditLogs: () => {
    set((state) => {
      state.auditLogs = [];
      state.pagination = {
        page: 1,
        limit: 50,
        total: 0,
        pages: 0
      };
    });
  },

})));

export default useAuditLogStore; 